import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Banner, RecipeCategories } from "@/utils/types/aem";
import { getAemData } from "./actions";

// Accessing the "banner" object

const initialState = {
  isLoading: false,
  isError: false,
  Banner: {} as Banner,
  RecipeCategories: {} as RecipeCategories,
  itemOrder: [] as any,
  Allergens: {} as any,
  Flyers: {} as any,
  ProductAvailabilityMessage: "" as any,
  NoProductFoundHeading: "" as any,
  NoProductFoundText: "" as any,
};

const GetProductAemDataSlice = createSlice({
  name: "productAem",
  initialState,
  reducers: {
    setProductAemData: (state, action) => {
      state.itemOrder =
        action?.payload?.[":items"]?.["root"]?.[":items"]?.["container"]?.[
          ":itemsOrder"
        ] || [];
      state.Banner =
        action?.payload?.[":items"]?.["root"]?.[":items"]?.["container"]?.[
          ":items"
        ]?.["banner"] || {};
      state.RecipeCategories =
        action?.payload?.[":items"]?.["root"]?.[":items"]?.["container"]?.[
          ":items"
        ]?.["columncontrol"]?.[":items"]?.["column-2"]?.[":items"]?.[
          "recipescategories"
        ] || {};

      state.Allergens = {
        allergensOptions:
          action?.payload?.[":items"]?.["root"]?.[":items"]?.["container"]?.[
            ":items"
          ]?.["columncontrol"]?.[":items"]?.["column-1"]?.[":items"]?.[
            "sortandfilter"
          ]?.["allergensOptionsMap"],

        title:
          action?.payload?.[":items"]?.["root"]?.[":items"]?.["container"]?.[
            ":items"
          ]?.["columncontrol"]?.[":items"]?.["column-1"]?.[":items"]?.[
            "sortandfilter"
          ]?.["allergensTitle"],
      };

      state.Flyers = {
        flyerOptions:
          action?.payload?.[":items"]?.["root"]?.[":items"]?.["container"]?.[
            ":items"
          ]?.["columncontrol"]?.[":items"]?.["column-1"]?.[":items"]?.[
            "sortandfilter"
          ]?.["flyersOptionsMap"],

        title:
          action?.payload?.[":items"]?.["root"]?.[":items"]?.["container"]?.[
            ":items"
          ]?.["columncontrol"]?.[":items"]?.["column-1"]?.[":items"]?.[
            "sortandfilter"
          ]?.["flyersTitle"],
      };

      state.ProductAvailabilityMessage =
        action?.payload?.[":items"]?.["root"]?.[":items"]?.["container"]?.[
          ":items"
        ]?.["text"]?.["text"] || "";

      const items =
        action?.payload?.[":items"]?.["root"]?.[":items"]?.["container"]?.[
          ":items"
        ]?.["columncontrol"]?.[":items"]?.["column-2"]?.[":items"] || {};

      let NoProductFoundHeading = "";
      let NoProductFoundText = "";

      Object.values(items).forEach((item:any) => {
        if (item?.id === "noProductsMatchHeading") {
          NoProductFoundHeading = item?.text || "";
        } else if (item?.id === "noMatchText") {
          NoProductFoundText = item?.text || "";
        }
      });

      state.NoProductFoundHeading = NoProductFoundHeading;

      state.NoProductFoundText =NoProductFoundText;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAemData.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(
      getAemData.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = false;

        state.itemOrder =
          action.payload[":items"]["root"][":items"]["container"][
            ":itemsOrder"
          ];
        state.Banner =
          action.payload[":items"]["root"][":items"]["container"][":items"][
            "banner"
          ];
        state.RecipeCategories =
          action.payload[":items"]["root"][":items"]["container"][":items"][
            "columncontrol"
          ][":items"]["column-2"][":items"]["recipescategories"];

        state.Allergens = {
          allergensOptions:
            action.payload[":items"]["root"][":items"]["container"][":items"][
              "columncontrol"
            ][":items"]["column-1"][":items"]["sortandfilter"][
              "allergensOptionsMap"
            ],

          title:
            action.payload[":items"]["root"][":items"]["container"][":items"][
              "columncontrol"
            ][":items"]["column-1"][":items"]["sortandfilter"][
              "allergensTitle"
            ],
        };

        state.Flyers = {
          flyerOptions:
            action.payload[":items"]["root"][":items"]["container"][":items"][
              "columncontrol"
            ][":items"]["column-1"][":items"]["sortandfilter"][
              "flyersOptionsMap"
            ],

          title:
            action.payload[":items"]["root"][":items"]["container"][":items"][
              "columncontrol"
            ][":items"]["column-1"][":items"]["sortandfilter"]["flyersTitle"],
        };

        state.ProductAvailabilityMessage =
          action.payload[":items"]["root"][":items"]["container"][":items"][
            "text"
          ]["text"];
      }
    );
    builder.addCase(getAemData.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});

export const { setProductAemData } = GetProductAemDataSlice.actions;

export const getProductAemDataSlice = GetProductAemDataSlice.reducer;
